import React from 'react';
import TextExtended from '../components/text-extended/text-extended';
import { useTranslate } from '../context/api-context/translations/use-translate';
import styles from './list-fetch-error-state-base.module.scss';
import { Button, HoverStyles } from '../../ui';
import { LIST_FETCH_ERROR_RETRY_BUTTON } from '../../common/constants/data-hooks';
const ListFetchErrorStateBase = ({ onRetry, dataHook, primaryKey, secondaryKey, ctaKey }) => {
    const t = useTranslate();
    return (React.createElement("div", { "data-hook": dataHook, className: styles.container },
        React.createElement("div", { className: styles.text },
            React.createElement(TextExtended, { priority: "primary" }, t(primaryKey))),
        React.createElement("div", { className: styles.text },
            React.createElement(TextExtended, { priority: "secondary" }, t(secondaryKey))),
        React.createElement("div", { className: styles.buttonContainer },
            React.createElement(Button, { onClick: onRetry, "data-hook": LIST_FETCH_ERROR_RETRY_BUTTON, hoverStyle: HoverStyles.underline }, t(ctaKey)))));
};
export default ListFetchErrorStateBase;
//# sourceMappingURL=list-fetch-error-state-base.js.map